import React from "react";
import type { Theme } from "@mui/material/styles";

export const getBorderBoxStyle = (theme: Theme): React.CSSProperties => ({
  borderColor: theme.palette.strokeColor?.secondary,
});
